'use client';

import { useTabTitleAnimation } from '@theme/hooks';
import { TabTitleAnimationType } from '@theme/types';

// Empty or invalid widget values fall back to the hook defaults
const toNumber = (value?: string) => Number(value) || undefined;

export default function ClientRoot({
  tabTitleAnimation,
  children
}: {
  tabTitleAnimation?: TabTitleAnimationType;
  children: React.ReactNode;
}) {
  useTabTitleAnimation({
    enabled: tabTitleAnimation?.is_active?.value !== 'passive',
    mode: tabTitleAnimation?.mode?.value,
    blinkTitleDuration: toNumber(tabTitleAnimation?.blink_title_duration?.value),
    blinkAltDuration: toNumber(tabTitleAnimation?.blink_alt_duration?.value),
    blinkAltText: tabTitleAnimation?.blink_alt_text?.value,
    marqueeInterval: toNumber(tabTitleAnimation?.marquee_interval?.value),
    marqueeStep: toNumber(tabTitleAnimation?.marquee_step?.value),
    marqueeSeparator: tabTitleAnimation?.marquee_separator?.value
  });

  return <>{children}</>;
}
